module.exports = __webpack_public_path__ + "img/alerts_black.26f4cc34.svg";